
import React, { useEffect, useState } from 'react';
import './Toast.css';

const Toast = ({ message, duration = 3000, onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const hideTimer = setTimeout(() => {
      setVisible(false);
    }, duration);
    return () => clearTimeout(hideTimer);
  }, [duration]);

  useEffect(() => {
    if (!visible) {
      const removeTimer = setTimeout(() => {
        onClose();
      }, 500); // tempo para o fade-out completar
      return () => clearTimeout(removeTimer);
    }
  }, [visible, onClose]);

  return (
    <div className={`toast ${visible ? 'toast--visible' : 'toast--hidden'}`}>
      {message}
    </div>
  );
};

export default Toast;
